/** eventsService */
class EventsService {
  constructor() {
    this.callbacks = {}
  }

  /**
   * @param {string} eventName
   * @param {*} data
   */
  dispatch(eventName, data = null) {
    if (this.callbacks[eventName]) {
      this.callbacks[eventName].forEach(callback => {
        callback(data);
      });
    }
  }

  /**
   * @param {string} eventName name of event
   * @param {Function} callback
   */
  addEventListener(eventName, callback) {
    if (!this.callbacks.hasOwnProperty(eventName)) {
      this.callbacks[eventName] = [];
    }
    this.callbacks[eventName].push(callback);
    
    // return unsubscribe
    return () => this.removeEventListener(eventName, callback)
  }

  /**
   * @param {string} eventName name of event
   * @param {Function} callback
   */
  removeEventListener(eventName, callback) {
    this.callbacks[eventName] = this.callbacks[eventName].filter(cb => cb !== callback)
  }
}

export default EventsService